function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Category=
function Category(id,name){_classCallCheck(this,Category);
this.id=id;
this.name=name;
};

export default Category;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9tb2RlbHMvQ2F0ZWdvcnkuanMiXSwibmFtZXMiOlsiQ2F0ZWdvcnkiLCJpZCIsIm5hbWUiXSwibWFwcGluZ3MiOiJvSkFBTUEsUztBQUNKLGtCQUFZQyxFQUFaLENBQWdCQyxJQUFoQixDQUFzQjtBQUNwQixLQUFLRCxFQUFMLENBQVVBLEVBQVY7QUFDQSxLQUFLQyxJQUFMLENBQVlBLElBQVo7QUFDRCxDOztBQUVILGNBQWVGLFNBQWYiLCJmaWxlIjoiQ2F0ZWdvcnkuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImNsYXNzIENhdGVnb3J5IHtcbiAgY29uc3RydWN0b3IoaWQsIG5hbWUpIHtcbiAgICB0aGlzLmlkID0gaWQ7XG4gICAgdGhpcy5uYW1lID0gbmFtZTtcbiAgfVxufVxuZXhwb3J0IGRlZmF1bHQgQ2F0ZWdvcnk7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/models/Category.js
// module id = 1711
// module chunks = 0